module.exports = __webpack_public_path__ + "img/form-bg.1866abc3.png";